// extracted by mini-css-extract-plugin
export default {"title":"WatchNext_title__9k+nH","btnLoading":"WatchNext_btnLoading__mflw3"};